import React from "react";
import ScheduleGarrisonUtils from "../utils/schedulegarrison-utils.jsx";

const AttachmentContent = ({ attachments, isUpdate = false }) => {
    if (!attachments) return null;

    const attachmentList = ScheduleGarrisonUtils.getAttachments(attachments, isUpdate);

    if (!attachmentList.length) return null;

    return (
        <tr className="bg-white attachment-content-table">
            <td colSpan={4}>
                <table className="w-full">
                    <thead>
                        <tr className="text-left">
                            <th colSpan={isUpdate ? 3 : 2}>
                                Anexos
                            </th>
                        </tr>

                        <tr>
                            <th style={{ width: "30%" }} />
                            <th style={{ width: isUpdate ? "35%" : "70%" }} />
                            {isUpdate && <th style={{ width: "35%" }} />}
                        </tr>
                    </thead>

                    <tbody>
                        { attachmentList.map((attachment, index) => {
                            const {current, previous} = isUpdate ? ScheduleGarrisonUtils.splitDiff(attachment) : {current: attachment, previous: {}};

                            return (
                                <React.Fragment key={attachment.id ?? index}>
                                    <ScheduleGarrisonUtils.Row
                                        isUpdate={isUpdate}
                                        label="Nome"
                                        value={!isUpdate ? current.name : undefined}
                                        newValue={ScheduleGarrisonUtils.getNew(attachment.name) ?? current.name}
                                        oldValue={ScheduleGarrisonUtils.getOld(attachment.name) ?? previous.name}
                                    />

                                    <ScheduleGarrisonUtils.Row
                                        isUpdate={isUpdate}
                                        label="Descrição"
                                        value={!isUpdate ? current.description : undefined}
                                        newValue={ScheduleGarrisonUtils.getNew(attachment.description) ?? current.description}
                                        oldValue={ScheduleGarrisonUtils.getOld(attachment.description) ?? previous.description}
                                    />
                                </React.Fragment>
                            );
                        })}
                    </tbody>
                </table>
            </td>
        </tr>
    );
};

export default AttachmentContent;